import { AutoMap } from '@automapper/classes';
import { ELifeCycleStatus } from 'src/app/domain/enums/life-cycle-status';

export class MeasureLingetteEntity {
    Id?: number;
    @AutoMap()
    Code!: string;
    @AutoMap()
    SamplingTime!: string;
    @AutoMap()
    Localisation!: string;
    @AutoMap()
    SamplingID!: number;
    @AutoMap()
    TypeSurface!: string;
    @AutoMap()
    ReferenceLot!: string;
    @AutoMap()
    Temoin!: string;
    @AutoMap()
    VisibilitePoussiere!: boolean;
    @AutoMap()
    SurfacePrelevement!: number;
    @AutoMap()
    Contexte!: number;
    @AutoMap()
    ApresNettoyage!: boolean;
    @AutoMap()
    IsCancelled!: boolean;
    @AutoMap()
    Observation?: string;
    @AutoMap()
    ReferenceEtiquette?: string;
    @AutoMap()
    Status: ELifeCycleStatus = ELifeCycleStatus.NotCompletedAndNotPositioned; 
    @AutoMap()
    Position!: number;
}
